import { QueryClientProvider } from '@tanstack/react-query'
import { createRootRoute, Outlet } from '@tanstack/react-router'
import { lazy, Suspense } from 'react'
import { ehErroDeRede, toastErro } from '@/lib/erros'
import { queryClient, setAvisoDeErro } from '@/lib/query'
import { AppToaster } from '@/ui/kit/AppToaster'
import { UiProviders } from '@/ui/UiProviders'

/*
 * As ferramentas de desenvolvimento entram por import dinâmico e só em DEV:
 * o bundle de produção não carrega nada disso, e a sala não pede byte
 * nenhum a mais enquanto a sessão está aberta.
 *
 * Fora também quando o navegador está sendo dirigido por automação. Elas
 * chegam depois da primeira pintura e o trabalho de montagem trava a linha
 * principal por tempo suficiente para a bolinha perder quadros: com elas
 * ligadas, `video.spec.ts` falha em três de cada cinco execuções na medida
 * de que a bolinha se move.
 */
const Devtools =
  import.meta.env.DEV && !navigator.webdriver
    ? lazy(async () => {
        const [router, query] = await Promise.all([
          import('@tanstack/react-router-devtools'),
          import('@tanstack/react-query-devtools'),
        ])
        return {
          default: function Devtools() {
            return (
              <>
                <router.TanStackRouterDevtools position="bottom-left" />
                <query.ReactQueryDevtools buttonPosition="bottom-right" />
              </>
            )
          },
        }
      })
    : null

// Erro que nenhuma tela tratou vira aviso. Rede caída em atualização de
// fundo fica com o `ConexaoAviso`, senão cada query repetiria o mesmo aviso.
setAvisoDeErro((error, origem) => {
  if (origem === 'query' && ehErroDeRede(error)) return
  toastErro(error)
})

export const Route = createRootRoute({
  component: function Root() {
    return (
      <QueryClientProvider client={queryClient}>
        <UiProviders>
          <Outlet />
          <AppToaster />
          {Devtools !== null && (
            <Suspense fallback={null}>
              <Devtools />
            </Suspense>
          )}
        </UiProviders>
      </QueryClientProvider>
    )
  },
})
